/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const batchUploadAddRole = params => {
  return axios.post(`${base}/adminuser/batch_add_role`, params)
}
export const batchUploadDelRole = params => {
  return axios.post(`${base}/adminuser/batch_del_role`, params)
}
export const batchUploadUpdateEmail = params => {
  return axios.post(`${base}/adminuser/batch_update_email`, params)
}




// WEBPACK FOOTER //
// ./src/views/platform-upload/platform-upload.api.js